import { addItemToCollection } from "directus/src/operations";

export async function createDepartment({ item }) {
  try {
    const data = await addItemToCollection("departments", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
